"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _FilterCardWrapper = _interopRequireDefault(require("../FilterCardWrapper/FilterCardWrapper"));
var _index = require("../../index");
var _checkboxFilter = require("./checkboxFilter.style");
// import { Components as CheckboxFilterComponents } from './filterBar.style';

function CheckboxFilter(_ref) {
  let {
    title,
    expanded,
    options = [],
    loading,
    values = [],
    fieldData = {},
    onCardToggle,
    onCheckboxSelect,
    onCheckboxMultiSelect,
    onSearchUpdateFacet
  } = _ref;
  const [searchQuery, setSearchQuery] = (0, _react.useState)('');
  const [currentOptions, setCurrentOptions] = (0, _react.useState)([]);
  const [computedOptions, setComputedOptions] = (0, _react.useState)(options);
  const [showMoreContentVisible, setShowMoreContentVisible] = (0, _react.useState)(false);
  const [showLessContentVisible, setShowLessContentVisible] = (0, _react.useState)(false);
  const [selectedVisibleValues, setSelectedVisibleValues] = (0, _react.useState)([]);
  const [visibleOptionsCount, setVisibleOptionsCount] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    setComputedOptions(searchQuery ? options.filter(option => {
      var _a;
      return (_a = option.value) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase().match(searchQuery.toLowerCase());
    }) : options);
  }, [options, searchQuery]);
  (0, _react.useEffect)(() => {
    setCurrentOptions(computedOptions === null || computedOptions === void 0 ? void 0 : computedOptions.slice(0, 5));
  }, [computedOptions]);
  (0, _react.useEffect)(() => {
    setSelectedVisibleValues(computedOptions.filter(option => {
      return values.indexOf(option.value) > -1;
    }));
  }, [JSON.stringify(values), computedOptions]);
  (0, _react.useEffect)(() => {
    if (currentOptions.length) {
      setVisibleOptionsCount(currentOptions.length);
      setShowMoreContentVisible(computedOptions.length > currentOptions.length);
      setShowLessContentVisible(currentOptions.length > 5);
    }
  }, [currentOptions, computedOptions]);
  const onSelectAll = (selectionType, selectedKey, currentOptions) => {
    const selectedOptions = currentOptions && currentOptions.length ? currentOptions.map(option => option.value) : [];
    onCheckboxMultiSelect(selectionType, selectedKey, fieldData, selectedOptions);
  };
  const onSearch = e => {
    setSearchQuery(e.target.value);
    onSearchUpdateFacet(e.target.value, fieldData.fieldName);
  };
  const onClear = () => {
    setSearchQuery('');
    onSearchUpdateFacet('', fieldData.fieldName);
  };
  const loadPaginatedData = type => {
    if (type === 'SHOW_MORE') {
      const count = currentOptions.length + 5;
      setCurrentOptions(computedOptions.slice(0, count));
    } else {
      const currentOptionLength = currentOptions.length - 5;
      const count = currentOptionLength < 5 ? 5 : currentOptionLength;
      setCurrentOptions(computedOptions.slice(0, count));
    }
  };
  const RenderCurrentOptions = (currentOptions, values) => {
    return currentOptions && currentOptions.map ? currentOptions.map((option, idx) => {
      return (0, _jsxRuntime.jsxs)(_checkboxFilter.Components.CheckboxArea, {
        children: [(0, _jsxRuntime.jsx)(_index.Checkbox, {
          id: idx.toString(),
          name: title,
          checked: values.indexOf(option.value) > -1,
          label: option.value,
          onChange: () => onCheckboxSelect(option.value, title, fieldData)
        }), (0, _jsxRuntime.jsx)("div", {
          children: (0, _jsxRuntime.jsx)("label", {
            children: option.count
          })
        })]
      }, idx);
    }) : '';
  };
  return (0, _jsxRuntime.jsx)(_checkboxFilter.Components.CheckboxFilterWrapper, {
    children: (0, _jsxRuntime.jsx)(_FilterCardWrapper["default"], {
      title: title,
      expanded: expanded,
      header: (options.length > 5 || searchQuery.length > 0) && (0, _jsxRuntime.jsx)(_index.Input, {
        id: "searchQuery",
        placeholder: "Type your search term..",
        value: searchQuery,
        clearButton: true,
        onChange: e => onSearch(e),
        onClear: onClear
      }),
      body: (0, _jsxRuntime.jsx)("div", {
        children: loading ? (0, _jsxRuntime.jsx)(_checkboxFilter.Components.CheckboxLoader, {
          children: (0, _jsxRuntime.jsx)(_index.LoadingIndicator, {
            label: "Fetching options..."
          })
        }) : (0, _jsxRuntime.jsx)(_checkboxFilter.Components.CheckboxContent, {
          children: currentOptions && currentOptions.length ? RenderCurrentOptions(currentOptions, values) : (0, _jsxRuntime.jsx)(_checkboxFilter.Components.NoResultCard, {
            children: (0, _jsxRuntime.jsx)("p", {
              children: "No result found"
            })
          })
        })
      }),
      footer: !loading && computedOptions.length > 0 && (0, _jsxRuntime.jsxs)(_checkboxFilter.Components.CheckboxFooter, {
        children: [(0, _jsxRuntime.jsxs)(_checkboxFilter.Components.CheckboxFooterCountSelection, {
          children: [(0, _jsxRuntime.jsx)(_checkboxFilter.Components.CheckboxFooterCount, {
            children: selectedVisibleValues.length ? selectedVisibleValues.length === options.length ? "Including all ".concat(selectedVisibleValues.length) : "Including ".concat(selectedVisibleValues.length, " of ").concat(options.length) : "Showing ".concat(visibleOptionsCount, " of ").concat(options.length)
          }), selectedVisibleValues.length === (options && options.length) ? (0, _jsxRuntime.jsx)(_checkboxFilter.Components.CheckboxFooterSelectAll, {
            children: (0, _jsxRuntime.jsx)("span", (0, _extends2["default"])({
              "data-testid": "filter-bar-select-none",
              onClick: () => {
                onSelectAll('selectNone', title);
              }
            }, {
              children: "Select none"
            }))
          }) : (0, _jsxRuntime.jsx)(_checkboxFilter.Components.CheckboxFooterSelectAll, {
            children: (0, _jsxRuntime.jsx)("span", (0, _extends2["default"])({
              "data-testid": "filter-bar-footer-select-all",
              onClick: () => {
                onSelectAll('selectAll', title, options);
              }
            }, {
              children: "Select all"
            }))
          })]
        }), (0, _jsxRuntime.jsxs)(_checkboxFilter.Components.CheckboxFooterShowArea, {
          children: [showMoreContentVisible && (0, _jsxRuntime.jsx)("span", (0, _extends2["default"])({
            "data-testid": "filter-bar-show-more",
            onClick: () => {
              loadPaginatedData('SHOW_MORE');
            }
          }, {
            children: "Show more"
          })), showLessContentVisible && (0, _jsxRuntime.jsx)("span", (0, _extends2["default"])({
            "data-testid": "filter-bar-show-less",
            onClick: () => {
              loadPaginatedData('SHOW_LESS');
            }
          }, {
            children: "Show less"
          }))]
        })]
      }),
      onCardToggle: onCardToggle
    })
  });
}
var _default = exports["default"] = CheckboxFilter;